import React from "react";

export interface PageTitle {
    size?:      number;
    className?: string;
    weight?:    "bold" | "semibold" | "normal";
    children:   React.ReactNode;
}

export function PageTitle( { size = 3, children, className = "", weight = "bold" }: PageTitle ) {
    const weightClass = weight === "semibold" ? "fw-semibold" : weight === "normal" ? "fw-normal" : "fw-bold";
    return <div className={`${className} fs-${size} ${weightClass}`}>
        {children}
    </div>;
}
